import { getSingleImgInfo } from '@/api/design'
import Vue from 'vue'
const gruopDesign = {
  state: {
    // 产品列表
    productInfoList: [],
    allDesignInfo: [],

    // 已选颜色列表
    colorsList: {},
    isDesign: false,
    activeFabricListGroup: []
  },
  getters: {},
  actions: {
    GetSingleImgInfoGruopDesign({ commit }, id) {
      return new Promise(resolve => {
        getSingleImgInfo(id).then(res => {
          commit('SET_PRODUCT_LIST_INFO', res.data)
          resolve(res.data)
        })
      })
    }
  },
  mutations: {
    SET_IS_DESIGN: (state, data) => {
      state.isDesign = data
    },
    SET_ACTIVE_FABRIC_LIST_GRUOP: (state, data) => {
      state.activeFabricListGroup = data
    },

    SET_ALL_DESIGN_INFO: (state, data) => {
      state.allDesignInfo = data
    },

    SET_COLORS_LIST: (state, data) => {
      data.colors.map(item => {
        Vue.set(item, 'checked', true)
        return item
      })
      Vue.set(state.colorsList, data.id, data.colors)
    },
    REMOVE_COLOR: (state, data) => {
      Vue.delete(state.colorsList, data.id)
    },
    RESET_COLOR: state => {
      state.colorsList = {}
    },
    SET_PRODUCT_LIST_INFO: (state, data) => {
      state.productInfoList.push(data)
    },
    REMOVE_PODUCT_INFO: (state, data) => {
      state.productInfoList.splice(data, 1)
    },
    RESET_PROCUT_INFO: state => {
      state.productInfoList = []
    }
  }
}
export default gruopDesign
